import { useMemo } from 'react';
import paginationStyles from '~/styles/pagination.module.css';
import IconArrowLeft from '~icons/tabler/arrow-left';
import IconArrowRight from '~icons/tabler/arrow-right';

type Props = {
  currentPage: number;
  total: number;
  perPage: number;
  onPageChange: (page: number) => void;
};

export default function Pagination({
  currentPage,
  total,
  perPage,
  onPageChange,
}: Props) {
  const pages = Math.ceil(total / perPage);

  const numbersList = useMemo(() => {
    const list = Array.from({ length: pages }, (_, index) => index + 1);

    return list.map((item) => {
      return (
        <button
          key={item}
          type="button"
          onClick={() => onPageChange(item)}
          disabled={currentPage === item}
          data-active={currentPage === item}
          className={paginationStyles.paginationButton}
        >
          {item}
        </button>
      );
    });
  }, [currentPage, onPageChange, pages]);

  return (
    <div>
      <div className={paginationStyles.pagination}>
        <button
          type="button"
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className={paginationStyles.paginationButton}
        >
          <IconArrowLeft />
          <span className={paginationStyles.paginationButtonText}>Previous</span>
        </button>

        {numbersList}

        <button
          type="button"
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === total}
          className={paginationStyles.paginationButton}
        >
          <IconArrowRight />
          <span className={paginationStyles.paginationButtonText}>Next</span>
        </button>
      </div>
    </div>
  );
}
